import './Label.css'

import { ReactNode } from 'react'

import { cx } from '../utilities/cx'

export type LabelProps = {
  className?: string
  children: ReactNode
}

export const Label = (props: LabelProps) => {
  const { className, children } = props
  return <div className={cx('label', className)}>{children}</div>
}
